import React, {RefObject, useLayoutEffect, useRef, useState} from "react"

import {FieldTableCellProps} from "../../../../render/table/table-cell"
import {EntityType} from "../../../../../gd/const/item"
import {isBulkSelection} from "../../../../../gd/right-click-menu"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"
import FieldNumber_TableCellCalculated_NotHovered from "./not-hovered"
import FieldNumber_TableCellCalculated_Hovered from "./hovered"
import FieldNumber_TableCellCalculated_EditValue from "./edit-value"
import {useForceUpdate} from "../../../../../gd/utils/dom-and-react/react-utils"

// const debug = "FieldNumber_TableCellCalculated"
const debug = false

export default function FieldNumber_TableCellCalculated(props: FieldTableCellProps) {

    const refEditable: RefObject<any> = useRef()

    const forceUpdate                   = useForceUpdate()
    const [isHovered, setIsHovered]     = useState(false)
    const [isEditValue, setIsEditValue] = useState(false)
    
    let isEditable: boolean
    switch (props.listItem.type) {
        case EntityType.TASK:
        case EntityType.PROJECT:
            isEditable = !props.manager.isReadOnly && (!props.field.isCustom || props.listItem.availableCustomFieldsIds.includes(props.field.fieldId))
            break

        case EntityType.EVENT:
        case EntityType.GROUP:
        default:
            isEditable = false
    }

    useLayoutEffect(()=>{
        if (isEditValue) {
            refEditable.current?.onClick()
        }
    }, [isEditValue])

    const onMouseEnter = () => {
        if (!isEditable) {
            return
        }
        setIsHovered(true)
    }

    const onMouseLeave = () => {
        setIsHovered(false)
    }

    const onValueChange = (value: number | null) => {

        props.listItem.item.setCustomFieldValue(props.field.fieldId, value)
        props.listItem.item.save()

        // need it because of calculated values
        props.manager.updateChildrenItems()

        FieldProto_updateView(props.manager, props.field)
    }

    const onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }

        e.stopPropagation()
        onValueChange(null)
        forceUpdate()
    }

    const onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }
        if (!isEditable) {
            return
        }

        setIsEditValue(true)
    }

    const onBlur = (e: React.SyntheticEvent) => {
        setIsEditValue(false)
        setIsHovered(false)

        props.onBlur?.(e)
    }

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isEditValue) {
        return (
            <FieldNumber_TableCellCalculated_EditValue
                ref         = {refEditable}
                style       = {style}
                field       = {props.field}
                listItem    = {props.listItem}
                manager     = {props.manager}
                onChange    = {props.onChange}
                onBlur      = {onBlur}
                onFocus     = {props.onFocus}
            />
        )
    } else if (isHovered) {
        return (
            <FieldNumber_TableCellCalculated_Hovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                isEditable      = {isEditable}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
                onClick         = {onClick}
                onDeleteClick   = {onDeleteClick}
            />
        )
    } else {
        return (
            <FieldNumber_TableCellCalculated_NotHovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    }
}
